import { CategoryNamesAndIds } from '@/pages/DiscoverCategories/constants/constant';

import { urlSafeTitle } from '../urls';

/**
 * SEO browse slugs that differ from `urlSafeTitle(single-word key)` in {@link CategoryNamesAndIds}
 * (mega-nav / Discover use `urlToSend` for Coins → `coins-currency-and-stamps`).
 */
const TOP_CATEGORY_SLUG_TO_ID: Readonly<Record<string, number>> = {
    'coins-currency-and-stamps': CategoryNamesAndIds.Coins,
};

/**
 * Resolves a top-level discover category slug (urlSafeTitle of display name) to category id.
 * Returns null when unknown — full browse resolution should use the category API.
 */
export const getTopCategoryIdFromSlug = (categorySlug: string): number | null => {
    const target = decodeURIComponent(categorySlug).toLowerCase();
    const fromAlias = TOP_CATEGORY_SLUG_TO_ID[target];
    if (fromAlias !== undefined) {
        return fromAlias;
    }
    for (const [name, id] of Object.entries(CategoryNamesAndIds)) {
        if (urlSafeTitle(name).toLowerCase() === target) {
            return id;
        }
    }
    return null;
};
